/**********************************************\
|Author: Ben Kile                              |
|Created Date: 2021                            |
|                                              |
|Description: Creates a new Fleet vehicle,     |
|it is nearly identical to VehicleDetails.tsx  | 
\**********************************************/
import React, { Component } from "react"
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import queryParams from "./Params"
import moment from "moment"
import { Button, FormControl, Modal, Spinner } from "react-bootstrap"
import Select from 'react-select';
import DatePicker from "../../../components/common/DatePicker"
import "./NewVehicle.css"
import axios from "axios";
import snackBar from "../../../utilities/snackBar/SnackBar";
import AxiosConfig from "../../../utilities/AxiosConfig";

interface NewVehicleProps {
    toggleNewVehicle: Function
    fleetReference: any
    getVehicles: Function
    userId: any
}

type NewVehicleTypes = {
    info: any
    eventType: string
    VehicleNumber: string
    VehicleStatusTypeDescription: string
    VehicleStatusTypeId: string
    ProfitCenterLongDesc: string
    VinNumber: string
    TitleState: string
    TitleNumber: string
    Year: string
    Color: string
    VehicleMake: string
    Make: string
    VehicleModel: string
    Model: string
    VehicleMakeId: string
    VehicleModelId: string
    Mileage: string
    DecalId: string
    MaintenanceNumber: string
    PurchaseDate: number
    PurchasePrice: string
    IsOwned: boolean
    LeaseNumber: string
    LeaseExpiration: number
    VehicleRentalClass: string
    RentalBaseRatePerDay: string
    RentalBaseRatePerWeek: string
    RentalBaseRatePerMonth: string
    RentalPickUpDate: number
    RentalDropOffDate: number
    RentalLicenseFees: string
    RentalAncillaryCharges: string
    RentalTaxes: string
    RegistrationExpiration: number
    RegistrationState: string
    License: string
    DispositionDate: number
    DispositionValue: string
    BuyerName: string
    BuyerAddress: string
    BuyerCity: string
    BuyerState: string
    BuyerZip: string
    BuyerPhone: string
    ready: boolean
    invalidNum: boolean
    saving: boolean
    typing: boolean
    typingVehicleNumberTimeout: number | any
    checkingVehicleNumber: boolean,
    takenVehicleNumber: boolean,
    availableVehicleNumber: boolean,
    filteredModels: any,
    latestModel: number,
    dirtyForm: boolean,
    confirmDiscard: boolean
}

class NewVehicle extends Component<NewVehicleProps, NewVehicleTypes> {


    infoInterval: any
    timeFormat = "YYYY-MM-DD HH:mm:ss"
    constructor(props: any) {
        super(props)
        this.state = {
            info: {},
            eventType: "",
            VehicleNumber: "",
            VehicleStatusTypeDescription: "",
            VehicleStatusTypeId: "",
            ProfitCenterLongDesc: "",
            TitleState: "",
            VinNumber: "",
            TitleNumber: "",
            Year: "",
            Color: "",
            VehicleMake: "",
            Make: "",
            VehicleModel: "",
            Model: "",
            Mileage: "",
            VehicleMakeId: "",
            VehicleModelId: "",
            DecalId: "",
            MaintenanceNumber: "",
            PurchaseDate: 0,
            PurchasePrice: "",
            IsOwned: false,
            LeaseNumber: "",
            LeaseExpiration: 0,
            VehicleRentalClass: "",
            RentalBaseRatePerDay: "",
            RentalBaseRatePerWeek: "",
            RentalBaseRatePerMonth: "",
            RentalPickUpDate: 0,
            RentalDropOffDate: 0,
            RentalLicenseFees: "",
            RentalAncillaryCharges: "",
            RentalTaxes: "",
            RegistrationExpiration: 0,
            RegistrationState: "",
            License: "",
            DispositionDate: 0,
            DispositionValue: "",
            BuyerName: "",
            BuyerAddress: "",
            BuyerCity: "",
            BuyerState: "",
            BuyerZip: "",
            BuyerPhone: "",
            ready: false,
            invalidNum: false,
            saving: false,
            typing: false,
            typingVehicleNumberTimeout: 0,
            checkingVehicleNumber: false,
            takenVehicleNumber: false,
            availableVehicleNumber: false,
            filteredModels: [],
            latestModel: new Date().getFullYear() + 1,
            dirtyForm: false,
            confirmDiscard: false
        }
        this.typingVehicleNumberListener = this.typingVehicleNumberListener.bind(this);
    }

    componentDidMount() {
        let closeOverview = document.getElementById("fleet-overview-close-btn")
        if (closeOverview) {
            closeOverview.click()
        }
    }

    setEventType = (type: string) => {
        this.setState({ eventType: type })
    }

    handleChange = (event: { target: { value: any } }) => {
        const eventTypes = Object.keys(this.state)
        for (let i = 0; i < eventTypes.length; i++) {
            if (this.state.eventType === eventTypes[i]) {
                const param: object = { [eventTypes[i]]: event.target.value }
                if (this.state.eventType === "VehicleNumber") {
                    this.typingVehicleNumberListener(event.target.value)
                }
                this.setState(param)
                this.appendParams(param)
            }
        }
    }

    appendParams = (param: object) => {
        let paramKey = Object.keys(param)
        let searchTearm = Object.values(param)
        queryParams[paramKey[0]] = searchTearm[0] + ""
        this.validateParams(queryParams)
    }

    clearParams = () => {
        for (let [key] of Object.entries(queryParams)) {
            queryParams[key] = ""
        }
        queryParams.IsCartasite = null
    }

    cleanParams = () => {
        for (let [key] of Object.entries(queryParams)) {
            if (queryParams[key] === "") {
                queryParams[key] = null
            }
        }
        return queryParams
    }

    validateParams = (params: any) => {
        let hasRequired = false
        let invalidNumber = false
        let vals = Object.values(params)
        let activeFields = -1
        if (params.VehicleNumber !== ""
            && params.VehicleStatusTypeId !== ""
            && (params.VinNumber.length >= 11 && params.VinNumber.length <= 17)
            && params.ProfitCenterId !== ""
            && params.VehicleMakeId !== ""
            && params.VehicleModelId !== ""
            && parseInt(params.Year) > 1968 && parseInt(params.Year) <= this.state.latestModel
        ) {
            hasRequired = true
        }

        if (isNaN(params.VehicleNumber)) {
            invalidNumber = true
            this.setState({ invalidNum: true })
        } else {
            invalidNumber = false
            this.setState({ invalidNum: false, ready: false })
        }

        if (hasRequired && !invalidNumber) {
            this.setState({ ready: true })
        }

        for (let i = 0; i < vals.length; i++) {
            if (vals[i] !== "") {
                activeFields += 1
            }
        }
        if (activeFields > 0) {
            this.setState({ dirtyForm: true })
        } else {
            this.setState({ dirtyForm: false })
        }
    }

    updateDropdown = (param: object) => {
        this.setState(param)
    }

    handlePurchaseDate = (val: number) => {
        this.setState({ PurchaseDate: val.valueOf() })
        this.appendParams({ PurchaseDate: moment(val.valueOf()).format(this.timeFormat) })
    }

    handleLeaseExpirationDate = (val: number) => {
        this.setState({ LeaseExpiration: val.valueOf() })
        this.appendParams({ LeaseExpiration: moment(val.valueOf()).format(this.timeFormat) })
    }

    handleRentalPickupDate = (val: number) => {
        this.setState({ RentalPickUpDate: val.valueOf() })
        this.appendParams({ RentalPickUpDate: moment(val.valueOf()).format(this.timeFormat) })
    }

    handleRentalDropOffDate = (val: number) => {
        this.setState({ RentalDropOffDate: val.valueOf() })
        this.appendParams({ RentalDropOffDate: moment(val.valueOf()).format(this.timeFormat) })
    }

    handleRegistrationExpirationDate = (val: number) => {
        this.setState({ RegistrationExpiration: val.valueOf() })
        this.appendParams({ RegistrationExpiration: moment(val.valueOf()).format(this.timeFormat) })
    }

    handleDispositionDate = (val: number) => {
        this.setState({ DispositionDate: val.valueOf() })
        this.appendParams({ DispositionDate: moment(val.valueOf()).format(this.timeFormat) })
    }

    setModel = (param: any, placeHolderText: string) => {
        this.setState({ Model: placeHolderText })
        this.appendParams(param)
        this.appendParams({ Model: placeHolderText })
    }

    setMake = (param: any, placeHolderText: string) => {
        queryParams.VehicleModel = ""
        queryParams.VehicleModelId = ""
        queryParams.Model = ""
        this.setState({ Make: placeHolderText, Model: "", filteredModels: [] })
        this.appendParams(param)
        this.appendParams({ Make: placeHolderText })
        if (param.VehicleMakeId !== "") {
            this.getModels(param.VehicleMakeId)
        } else {
            this.setModel([{ VehicleModelId: "" }], "--Select Model--")
            this.setState({ filteredModels: [] })
        }
    }

    getModels = (modelId: number) => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/getVehicleModelsByMake/" + modelId, AxiosConfig.configValue())
            .then(res => {
                let models: any = res.data.vehicleModels.sort((a: any, b: any) => (a.text > b.text) ? 1 : -1)
                this.setState({ filteredModels: models })
                //console.log(res)
            }).catch(err => {
                //console.log(err)
            })
    }

    toggleOwned = (type: string) => {
        let str = type.split("-")
        if (str[1] === "t") {
            const obj: object = { [str[0]]: true }
            this.setState(obj)
            this.appendParams(obj)
        } else {
            const obj: object = { [str[0]]: false }
            this.setState(obj)
            this.appendParams(obj)
        }
    }

    typingVehicleNumberListener = (input: any) => {
        if (!isNaN(input)) {
            this.setState({ checkingVehicleNumber: true, takenVehicleNumber: false, availableVehicleNumber: false })
            const self = this;
            if (self.state.typingVehicleNumberTimeout) {
                clearTimeout(self.state.typingVehicleNumberTimeout);
            }
            self.setState(
                {
                    typing: false,
                    typingVehicleNumberTimeout: setTimeout(function () {
                        self.checkIfVehicleNumberTaken(input)
                    }, 1000)
                });
        } else {
            this.setState({ checkingVehicleNumber: false, takenVehicleNumber: false, availableVehicleNumber: false })
        }
    }

    checkIfVehicleNumberTaken = (input: string) => {
        this.setState({ takenVehicleNumber: false, availableVehicleNumber: false })
        if (input !== "") {
            axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/validateVehicleNumber/" + input, AxiosConfig.configValue("min"))
                .then(res => {
                    if (res.data > 0) {
                        this.setState({ checkingVehicleNumber: false, takenVehicleNumber: true, availableVehicleNumber: false })
                    } else {
                        this.setState({ checkingVehicleNumber: false, takenVehicleNumber: false, availableVehicleNumber: true })
                    }
                })
                .catch(err => {
                    //console.log(err, err.response);
                    AxiosConfig.handleError(err);
                    this.setState({ checkingVehicleNumber: false, takenVehicleNumber: false, availableVehicleNumber: false })
                })
        }
    }

    closeWindow = () => {
        if (this.state.dirtyForm) {
            this.setState({ confirmDiscard: true })
        } else {
            this.clearParams()
            this.props.toggleNewVehicle()
        }
    }

    discard = (discard: boolean) => {
        if (discard) {
            this.clearParams()
            this.props.toggleNewVehicle()
        }
        else {
            this.setState({ confirmDiscard: false })
        }

    }

    saveChanges = () => {
        this.setState({ saving: true })
        let requestBody = this.cleanParams()
        requestBody.CreatedDate = Date.now()
        requestBody.CreatedBy = this.props.userId
        requestBody.ModifiedBy = this.props.userId
        let vin = requestBody.VinNumber
        requestBody.VinNumber = vin.toUpperCase()
        requestBody.DecalId = this.state.VehicleNumber
        axios.post(process.env.REACT_APP_API_URL + "/api/Fleet/CreateOrUpdateVehicleInformation", requestBody, AxiosConfig.configValue("min"))
            .then(res => {
                this.clearParams()
                this.setState({ saving: false })
                snackBar({ text: "Vehicle Added", type: "success", timeout: 3000 })
                this.props.getVehicles({ VehicleNumber: this.state.VehicleNumber })
                this.props.toggleNewVehicle()
            })
            .catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
                this.setState({ saving: false })
                snackBar({ text: "Error Adding Vehicle", type: "error", timeout: 3000 })
                this.props.toggleNewVehicle()
            })
    }

    render() {

        // //console.log(this.props.fleetReference)
        // //console.log(queryParams)
        // //console.log(this.props.userId)

        return (
            <div className="NewVehicle">
                {this.state.confirmDiscard && <Modal id="fleet-new-vehicle-discard-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                >
                    <Modal.Header>
                        Are you sure you want to quit? Any unsaved changes will be lost.
                    </Modal.Header>
                    <Modal.Footer>
                        <div id="fleet-new-vehicle-discard-modal-footer" >
                            <Button id="fleet-new-vehicle-discard-modal-footer-quit-btn" variant="danger" onClick={() => this.discard(true)}>Quit</Button>
                            <Button id="fleet-new-vehicle-discard-modal-footer-back-btn" variant="secondary" onClick={() => this.discard(false)}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
                {!this.state.confirmDiscard && <Modal id="fleet-new-vehicle-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    size="xl"
                >
                    <Modal.Header>
                        <p id="add-new-vehicle-modal-header">Add New Vehicle</p>
                    </Modal.Header>
                    <div className="NewVehicleInfoWrapper">
                        <div className="R1-Header">
                            <div id="vehicle-details-column-header">
                                <p >General Info</p>
                            </div>
                            <div id="vehicle-details-column-header">
                                <p >Title Info</p>
                            </div>
                            <div id="vehicle-details-column-header">
                                <p >Purchase Info</p>
                            </div>
                        </div>
                        {this.props.fleetReference.vehicleMakes && <div className="Vehicle-Details-R1">
                            <div className="Vehicle-Details-C1">
                                <div id="vehicle-number-check-wrapper">
                                    <p>Vehicle Number{queryParams.VehicleNumber === "" && <span id="vehicle-details-required-marker">*</span>}</p>
                                    {this.state.checkingVehicleNumber && !this.state.takenVehicleNumber && queryParams.VehicleNumber !== "" && <Spinner id="checking-vehicle-number-spinner" animation="border" variant="secondary" />}
                                    {this.state.takenVehicleNumber && <p id="vehicle-number-taken"><span className="material-icons">priority_high</span>({queryParams.VehicleNumber} already exists)</p>}
                                    {this.state.availableVehicleNumber && <span id="vehicle-number-available" className="material-icons">done</span>}
                                </div>
                                <FormControl
                                    onFocus={() => this.setEventType("VehicleNumber")}
                                    placeholder={"1234..."}
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.VehicleNumber}
                                    name="MaintenanceNum"
                                />
                                <p>Status{queryParams.VehicleStatusTypeId === "" && <span id="vehicle-details-required-marker">*</span>}{queryParams.VehicleStatusTypeId !== "" && <span id="add-vehicle-field-filled" className="material-icons">done</span>}</p>
                                <Select
                                    id="dropdown-basic-button-fleet-details-btn"
                                    value={{ label: this.state.VehicleStatusTypeDescription || "--Status--" }}
                                    options={this.props.fleetReference.vehicleStatusTypes.map((s: any) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: any) => {
                                        this.appendParams({ VehicleStatusTypeId: parseInt(item.value) })
                                        this.updateDropdown({ VehicleStatusTypeDescription: item.label })
                                    }}
                                    menuPosition="fixed"
                                />
                                <p>Profit Center{queryParams.ProfitCenterId === "" && <span id="vehicle-details-required-marker">*</span>}{queryParams.ProfitCenterId !== "" && <span id="add-vehicle-field-filled" className="material-icons">done</span>}</p>
                                <Select
                                    id="dropdown-basic-button-fleet-details-btn"
                                    value={{ label: this.state.ProfitCenterLongDesc || "--Profit Center--" }}
                                    options={this.props.fleetReference.profitCenters.map((s: any) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: any) => {
                                        this.appendParams({ ProfitCenterId: parseInt(item.value) })
                                        this.updateDropdown({ ProfitCenterLongDesc: item.label })
                                    }}
                                    menuPosition="fixed"
                                />
                            </div>
                            <div className="Vehicle-Details-C2">
                                <p>Vin{!(queryParams.VinNumber.length >= 11 && queryParams.VinNumber.length <= 17) && <span id="vehicle-details-required-marker">*</span>}{(queryParams.VinNumber.length >= 11 && queryParams.VinNumber.length <= 17) && <span id="add-vehicle-field-filled" className="material-icons">done</span>}</p>
                                <FormControl
                                    onFocus={() => this.setEventType("VinNumber")}
                                    placeholder={"11-17 characters"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.VinNumber.toUpperCase()}
                                />
                                <p>Vehicle Make{queryParams.Make === "" && <span id="vehicle-details-required-marker">*</span>}{queryParams.Make !== "" && <span id="add-vehicle-field-filled" className="material-icons">done</span>}</p>
                                {/**********************************************************************/}
                                <Select
                                    id="dropdown-basic-button-fleet-details-btn"
                                    value={{ label: this.state.Make || "--Make--" }}
                                    options={this.props.fleetReference.vehicleMakes.map((s: any) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: any) => {
                                        this.setMake({ VehicleMakeId: item.value }, item.label)
                                        // this.appendParams({ VehicleMakeId: item.value })
                                        // this.appendParams({ Make: item.label })
                                        this.updateDropdown({ Make: item.label })
                                    }}
                                    menuPosition="fixed"
                                />
                                <p>Vehicle Model{queryParams.Model === "" && <span id="vehicle-details-required-marker">*</span>}{queryParams.Model !== "" && <span id="add-vehicle-field-filled" className="material-icons">done</span>}</p>
                                <Select
                                    id="dropdown-basic-button-fleet-details-btn"
                                    value={{ label: this.state.Model || "--Model--" }}
                                    options={this.state.filteredModels.map((s: any) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: any) => {
                                        // this.appendParams({ VehicleModelId: item.value })
                                        // this.appendParams({ Model: item.label })
                                        this.setModel({ VehicleModelId: item.value }, item.label)
                                        this.updateDropdown({ Model: item.label })
                                    }}
                                    menuPosition="fixed"
                                />
                                <p>Vehicle Year{!(parseInt(queryParams.Year) > 1968 && parseInt(queryParams.Year) <= this.state.latestModel) && <span id="vehicle-details-required-marker">*</span>}{(parseInt(queryParams.Year) > 1968 && parseInt(queryParams.Year) <= this.state.latestModel) && <span id="add-vehicle-field-filled" className="material-icons">done</span>}</p>
                                <FormControl
                                    onFocus={() => this.setEventType("Year")}
                                    placeholder={"1969-" + this.state.latestModel}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.Year}
                                />
                                <p>Title State</p>
                                <Select
                                    id="dropdown-basic-button-fleet-details-btn"
                                    value={{ label: this.state.TitleState || "--Title State--" }}
                                    options={this.props.fleetReference.states.map((s: any) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: any) => {
                                        this.appendParams({ TitleState: item.label })
                                        this.updateDropdown({ TitleState: item.label })
                                    }}
                                    menuPosition="fixed"
                                />
                                <p>Title Number</p>
                                <FormControl
                                    onFocus={() => this.setEventType("TitleNumber")}
                                    placeholder={"Title #"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.TitleNumber}
                                />
                                <p>Vehicle Color</p>
                                <FormControl
                                    onFocus={() => this.setEventType("Color")}
                                    placeholder={"Color"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.Color}
                                />
                                <p>Vehicle Mileage</p>
                                <FormControl
                                    onFocus={() => this.setEventType("Mileage")}
                                    placeholder={"Mileage"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.Mileage || ""}
                                />
                                <p>Drivers Hotline Decal #</p>
                                <FormControl
                                    onFocus={() => this.setEventType("DecalId")}
                                    placeholder={"Decal #"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.DecalId || ""}
                                />
                                <p>Maintenance #</p>
                                <FormControl
                                    onFocus={() => this.setEventType("MaintenanceNumber")}
                                    placeholder={"Maintenance #"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.MaintenanceNumber || ""}
                                />
                                <div className="Vehicle-Details-Vanity-Bar"></div>
                            </div>
                            <div className="Vehicle-Details-C3">
                                <p>Purchase Date</p>
                                <DatePicker value={this.state.PurchaseDate || ""} onChange={this.handlePurchaseDate} type="input" useCloseCallback />
                                <p>Original Purchase Price</p>
                                <FormControl
                                    onFocus={() => this.setEventType("PurchasePrice")}
                                    placeholder={"$"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.PurchasePrice || ""}
                                />
                                <p>Fully Owned</p>
                                {this.state.IsOwned && <Button variant="outline-light" id="vehicle-details-is-owned-t" onClick={() => this.toggleOwned("IsOwned-f")}>
                                    <span className="material-icons">done</span>
                                </Button>}
                                {!this.state.IsOwned && <Button variant="outline-light" id="vehicle-details-is-owned-f" onClick={() => this.toggleOwned("IsOwned-t")}>
                                    <span className="material-icons">close</span>
                                </Button>}
                                <p>Lease #</p>
                                <FormControl
                                    onFocus={() => this.setEventType("LeaseNumber")}
                                    placeholder={"Lease #"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.LeaseNumber || ""}
                                />
                                <p>Lease Expiration</p>
                                <DatePicker value={this.state.LeaseExpiration || ""} onChange={this.handleLeaseExpirationDate} type="input" useCloseCallback />
                                <div className="Vehicle-Details-Vanity-Bar"></div>
                            </div>
                        </div>}
                        <div className="R2-Header">
                            <div id="vehicle-details-column-header">
                                <p >Rental Info</p>
                            </div>
                            <div id="vehicle-details-column-header">
                                <p >Registration Info</p>
                            </div>
                            <div id="vehicle-details-column-header">
                                <p >Disposition Info</p>
                            </div>
                        </div>
                        {this.props.fleetReference.vehicleMakes && <div className="Vehicle-Details-R2">
                            <div className="Vehicle-Details-C4">
                                <p>Vehicle Class Requested</p>
                                <Select
                                    id="dropdown-basic-button-fleet-details-btn"
                                    value={{ label: this.state.VehicleRentalClass || "--Rental Class--" }}
                                    options={this.props.fleetReference.vehicleRentalClasses.map((s: any) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: any) => {
                                        this.appendParams({ VehicleRentalClassId: item.value })
                                        this.updateDropdown({ VehicleRentalClass: item.label })
                                    }}
                                    menuPosition="fixed"
                                />
                                <p>Base Rate Per Day</p>
                                <FormControl
                                    onFocus={() => this.setEventType("RentalBaseRatePerDay")}
                                    placeholder={"$"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.RentalBaseRatePerDay || ""}
                                />
                                <p>Base Rate Per Week</p>
                                <FormControl
                                    onFocus={() => this.setEventType("RentalBaseRatePerWeek")}
                                    placeholder={"$"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.RentalBaseRatePerWeek || ""}
                                />
                                <p>Base Rate Month </p>
                                <FormControl
                                    onFocus={() => this.setEventType("RentalBaseRatePerMonth")}
                                    placeholder={"$"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.RentalBaseRatePerMonth || ""}
                                />
                                <p>Date Vehicle Picked Up</p>
                                <DatePicker value={this.state.RentalPickUpDate || ""} onChange={this.handleRentalPickupDate} type="input" useCloseCallback />
                                <p>Date Vehicle Returned</p>
                                <DatePicker value={this.state.RentalDropOffDate || ""} onChange={this.handleRentalDropOffDate} type="input" useCloseCallback />
                                <p>License Fees	</p>
                                <FormControl onFocus={() => this.setEventType("RentalLicenseFees")}
                                    placeholder={"$"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.RentalLicenseFees || ""}
                                />
                                <p>Ancillary Charges</p>
                                <FormControl
                                    onFocus={() => this.setEventType("RentalAncillaryCharges")}
                                    placeholder={"$"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.RentalAncillaryCharges || ""}
                                />
                                <p>Taxes</p>
                                <FormControl
                                    onFocus={() => this.setEventType("RentalTaxes")}
                                    placeholder={"$"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.RentalTaxes || ""}
                                />
                                <div className="Vehicle-Details-Vanity-Bar"></div>
                            </div>
                            <div className="Vehicle-Details-C5">
                                <p>Registration Expiration</p>
                                <DatePicker value={this.state.RegistrationExpiration || ""} onChange={this.handleRegistrationExpirationDate} type="input" useCloseCallback />
                                <p>Registration State</p>
                                <Select
                                    id="dropdown-basic-button-fleet-details-btn"
                                    value={{ label: this.state.RegistrationState || "--Registration State--" }}
                                    options={this.props.fleetReference.states.map((s: any) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: any) => {
                                        this.appendParams({ RegistrationState: item.value })
                                        this.updateDropdown({ RegistrationState: item.label })
                                    }}
                                    menuPosition="fixed"
                                />
                                <p>License Number</p>
                                <FormControl
                                    onFocus={() => this.setEventType("License")}
                                    placeholder={"License #"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.License || ""}
                                />
                            </div>
                            <div className="Vehicle-Details-C6">
                                <p>Disposition Date</p>
                                <DatePicker value={this.state.DispositionDate || ""} onChange={this.handleDispositionDate} type="input" useCloseCallback />
                                <p>Disposition Value</p>
                                <FormControl
                                    onFocus={() => this.setEventType("DispositionValue")}
                                    placeholder={"$"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.DispositionValue || ""}
                                />
                                <p>Buyer Name</p>
                                <FormControl
                                    onFocus={() => this.setEventType("BuyerName")}
                                    placeholder={"Name"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.BuyerName || ""}
                                />
                                <p>Buyer Address</p>
                                <FormControl
                                    onFocus={() => this.setEventType("BuyerAddress")}
                                    placeholder={"Address"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.BuyerAddress || ""}
                                />
                                <p>Buyer City</p>
                                <FormControl
                                    onFocus={() => this.setEventType("BuyerCity")}
                                    placeholder={"City"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.BuyerCity || ""}
                                />
                                <p>Buyer State</p>
                                <Select
                                    id="dropdown-basic-button-fleet-details-btn"
                                    value={{ label: this.state.BuyerState || "State" }}
                                    options={this.props.fleetReference.states.map((s: any) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: any) => {
                                        this.appendParams({ BuyerState: item.value })
                                        this.updateDropdown({ BuyerState: item.label })
                                    }}
                                    menuPosition="fixed"
                                />
                                <p>Buyer Zip</p>
                                <FormControl
                                    onFocus={() => this.setEventType("BuyerZip")}
                                    placeholder={"Zip"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.BuyerZip || ""}
                                />
                                <p>Buyer Phone</p>
                                <FormControl
                                    onFocus={() => this.setEventType("BuyerPhone")}
                                    placeholder={"Phone #"}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.BuyerPhone || ""}
                                />
                                <div className="Vehicle-Details-Vanity-Bar"></div>
                            </div>
                        </div>}
                    </div>
                    <Modal.Footer>
                        {this.state.invalidNum && <p id="invalid-vehicle-num-nag">Invalid Vehicle Number, must be numeric!</p>}
                        <Button variant="secondary" onClick={() => this.closeWindow()}>Cancel</Button>
                        {this.state.ready && !this.state.invalidNum && <Button id="create-vehicle-btn" onClick={() => this.saveChanges()}>Create</Button>}
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
    sideMenuOpen: state.menu.sideMenuOpen
})

export default connect(mapStateToProps)(NewVehicle)